/** How long Larry waits for the host's `init` (the session token) after posting `ready`. */
export const HOST_INIT_TIMEOUT_MS = 15_000

/**
 * At most one `activity` message per this interval. The host's keepalive goes idle after 2 minutes
 * without activity it can see, so this keeps it well inside that window.
 */
export const HOST_ACTIVITY_THROTTLE_MS = 30_000
